import React from 'react'
import * as pageUtils from './__index.utils'
import { formatStrapiText } from '@utils/methods'
import { DOSSIER_FORM } from './__index.utils'
import { MODAL } from '@pages/auth/requests/__[id].utils'
import { pushEvent } from '@utils/tracking'

type propsType = {
	dossier: DOSSIER_FORM | undefined
	pageData: any
	setRedirect: (value: boolean) => void
	onToggleModal: (modalType: string) => void
}

const PaymentDueSection: React.FC<propsType> = ({
	dossier,
	pageData,
	setRedirect,
	onToggleModal
}) => {
	const formatMontant = (montant: string | undefined) =>
		Number(montant).toLocaleString('fr-CA', {
			minimumFractionDigits: 2
		}) + '$'

	const trackPaymentServiceStart = () => {
		pushEvent('service_start', {
			service_name: 'payment_request',
			destination_site: process.env.PAYMENT_LAVAL_PERMIS_URL
		})
	}

	return (
		<>
			<div className={pageUtils.classes.bloc}>
				<h3 className={pageUtils.classes.h3}>
					{formatStrapiText(
						pageData?.assets?.page_requestDetails_payment_to_be_made
					)}
				</h3>

				<div>
					<strong> Numéro de référence: </strong>
					{dossier?.NO_REFERENCE}
				</div>

				<div>
					<strong> Numéro de dossier: </strong>
					{dossier?.NO_DOSSIER}
				</div>

				<div>
					<strong> Montant à payer: </strong>
					{formatMontant(dossier?.SOLDE)}
				</div>

				{dossier?.IND_PEL_DISPONIBLE === 'O' && (
					<>
						<div className={pageUtils.classes.buttonContainer}>
							<button
								className={pageUtils.classes.button}
								onClick={() => {
									trackPaymentServiceStart()
									onToggleModal(MODAL.REDIRECT)
									window.open(
										`${process.env.PAYMENT_LAVAL_PERMIS_URL}?p_no_reference=${dossier?.NO_REFERENCE}&p_no_dossier=${dossier?.NO_DOSSIER}`,
										'_blank',
										'noopener,noreferrer'
									)
								}}
							>
								{pageData?.assets?.label_pay_now}
							</button>
						</div>
					</>
				)}
			</div>
		</>
	)
}

export default PaymentDueSection
